import { useIntl } from 'react-intl';

import type { CaliberProps } from '@/components/PlaceholderCaliberTab/const';
import { STATICIMAGES_PATH_PREFIX } from '@/lib/const';
import { aboutMessages } from '@/messages/about';

import * as S from './Caliber.styles';
const INT_CALIBERIMAGES_PREFIX = 'caliberImages';
export const Caliber = (props: CaliberProps) => {
  const { formatMessage } = useIntl();
  const renderMessages = (type: string) => {
    const id = `${props.id}${type}`;
    return (
      aboutMessages[id as keyof typeof aboutMessages] ??
      aboutMessages.chronographs
    );
  };
  const imagePrefix = STATICIMAGES_PATH_PREFIX + INT_CALIBERIMAGES_PREFIX;
  return (
    <S.CaliberWrapper>
      {props.imgUrl && (
        <S.Media>
          <S.Image
            alt={props.id}
            className='default'
            data-test-id='CaliberImage'
            height='0'
            loading='lazy'
            src={imagePrefix + props.imgUrl}
            width='0'
          />
        </S.Media>
      )}
      <S.Content>
        <S.Title>{formatMessage(renderMessages('Title'))}</S.Title>
        <S.Text>{formatMessage(renderMessages('Description'))}</S.Text>
        <S.DescriptionGroup>
          <S.DescriptionItem>
            {formatMessage(renderMessages('Power'))}
          </S.DescriptionItem>
          {renderMessages('Diamonds').defaultMessage && (
            <S.DescriptionItem>
              {formatMessage(renderMessages('Diamonds'))}
            </S.DescriptionItem>
          )}
          <S.DescriptionItem>
            {formatMessage(renderMessages('Cosc'))}
          </S.DescriptionItem>
        </S.DescriptionGroup>
      </S.Content>
    </S.CaliberWrapper>
  );
};
